// extracted by mini-css-extract-plugin
module.exports = {"adaptiveCardWithoutPadding":"AdaptiveCard_adaptiveCardWithoutPadding__4fYWW","adaptiveCardVertical":"AdaptiveCard_adaptiveCardVertical__jNfb1"};